module.exports = __webpack_public_path__ + "static/media/name.0b87499b.svg";